<template>
  <div class="onboarding-banner" v-if="visible">
    <div class="onboarding-banner-content">
      <div class="onboarding-banner-icon">
        <i class="bx bx-rocket"></i>
      </div>
      <div class="onboarding-banner-text">
        <h3 class="onboarding-banner-title">Bem-vindo ao seu evento!</h3>
        <p class="onboarding-banner-desc">Preparamos um tour guiado para ajudar você a configurar tudo rapidamente.</p>
      </div>
      <div class="onboarding-banner-actions">
        <button class="onboarding-btn-start" @click="$emit('start-tour')">
          <i class="bx bx-play-circle"></i> Iniciar Tour Guiado
        </button>
        <button class="onboarding-btn-dismiss" @click="dismiss">
          Dispensar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { TourManager } from '../TourManager'

export default {
  name: 'OnboardingBanner',
  data () {
    return {
      dismissed: localStorage.getItem('onboarding_banner_dismissed') === 'true'
    }
  },
  computed: {
    visible () {
      return !TourManager.isCompleted('setup-tour') && !this.dismissed
    }
  },
  methods: {
    dismiss () {
      this.dismissed = true
      localStorage.setItem('onboarding_banner_dismissed', 'true')
    }
  }
}
</script>

<style scoped>
.onboarding-banner {
  background: linear-gradient(135deg, #556ee6 0%, #3b82f6 50%, #6366f1 100%);
  border-radius: 5px;
  padding: 24px 28px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(85, 110, 230, 0.25);
  animation: bannerSlideIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes bannerSlideIn {
  from { opacity: 0; transform: translateY(-12px); }
  to { opacity: 1; transform: translateY(0); }
}

.onboarding-banner-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.onboarding-banner-icon {
  width: 52px;
  height: 52px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #fff;
  flex-shrink: 0;
}

.onboarding-banner-text {
  flex: 1;
  min-width: 0;
}

.onboarding-banner-title {
  font-size: 17px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 4px 0;
}

.onboarding-banner-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
  line-height: 1.4;
}

.onboarding-banner-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.onboarding-btn-start {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background: #fff;
  color: #556ee6;
  transition: all 0.2s;
  white-space: nowrap;
}

.onboarding-btn-start:hover {
  background: #f0f2ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.onboarding-btn-start i {
  font-size: 18px;
}

.onboarding-btn-dismiss {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  padding: 6px 10px;
  border-radius: 6px;
  transition: all 0.2s;
  white-space: nowrap;
}

.onboarding-btn-dismiss:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}
</style>
